import {Divider} from '@vio/atlas/Divider'
import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {HotelLocationContent} from '../../HotelLocationContent'

import type {ContentHotel} from '@findhotel/sapi'

interface Props {
  descriptions: ContentHotel['descriptions']
  attractions: ContentHotel['location']['poi']
  variant?: 'overlay' | 'detailsTab' | 'compact'
}

const HotelPropertyInfoContent: React.FC<Props> = ({
  descriptions,
  attractions,
  variant = 'overlay'
}) => {
  const {amenities, business_amenities, dining, rooms} = descriptions

  switch (variant) {
    case 'compact':
      return (
        <div>
          <Box display="flex" alignItems="center" marginBottom="s400">
            <Text variant="labelM">
              <FormattedMessageWrapper
                id="amenities"
                defaultMessage="Amenities"
              />
            </Text>
          </Box>
          <Text variant="bodyM" dir="auto">
            {amenities}
          </Text>
        </div>
      )
    case 'overlay':
      return (
        <div data-id="HotelPropertyInfoContent">
          {amenities && (
            <Box marginBottom="s700">
              <Box
                display="flex"
                gap="s300"
                alignItems="center"
                marginBottom="s400"
              >
                <Icon
                  name="ServiceBell"
                  colorPath="content.neutral.secondary"
                />
                <Text variant="titleL" tag="p">
                  <FormattedMessageWrapper
                    id="amenities"
                    defaultMessage="Amenities"
                  />
                </Text>
              </Box>
              <Text variant="bodyM" dir="auto">
                {amenities}
              </Text>
            </Box>
          )}
          {business_amenities && (
            <div>
              <Box marginBottom="s300">
                <Text variant="labelM">
                  <FormattedMessageWrapper
                    id="businessAmenities"
                    defaultMessage="Business amenities"
                  />
                </Text>
              </Box>
              <Text variant="bodyM" dir="auto">
                {business_amenities}
              </Text>
            </div>
          )}
          {(amenities || business_amenities) && (
            <Box paddingBottom="s700" paddingTop="s700">
              <Divider />
            </Box>
          )}
          {dining && (
            <>
              <div>
                <Box
                  display="flex"
                  gap="s300"
                  alignItems="center"
                  marginBottom="s400"
                >
                  <Icon
                    name="Restaurant"
                    colorPath="content.neutral.secondary"
                  />
                  <Text variant="titleL" tag="p">
                    <FormattedMessageWrapper
                      id="dining"
                      defaultMessage="Dining"
                    />
                  </Text>
                </Box>
                <Text variant="bodyM" dir="auto">
                  {dining}
                </Text>
              </div>
              {/* Divider between dining and rooms */}
              <Box paddingBottom="s700" paddingTop="s700">
                <Divider />
              </Box>
            </>
          )}
          {rooms && (
            <>
              <div>
                <Box
                  display="flex"
                  gap="s300"
                  alignItems="center"
                  marginBottom="s400"
                >
                  <Icon name="Room" colorPath="content.neutral.secondary" />
                  <Text variant="titleL" tag="p">
                    <FormattedMessageWrapper
                      id="rooms"
                      defaultMessage="Rooms"
                    />
                  </Text>
                </Box>
                <Text variant="bodyM" dir="auto">
                  {rooms}
                </Text>
              </div>
              {/* Divider between dining and rooms */}
              <Box paddingBottom="s700" paddingTop="s700">
                <Divider />
              </Box>
            </>
          )}
          <Box paddingBottom="s900">
            <HotelLocationContent
              descriptions={descriptions}
              attractions={attractions}
              variant="amenitiesTab"
            />
          </Box>
        </div>
      )
    case 'detailsTab':
    default: {
      return (
        <div>
          {amenities && (
            <Box marginBottom="s700">
              <Box display="flex" alignItems="center" marginBottom="s400">
                <Text variant="labelM">
                  <FormattedMessageWrapper
                    id="amenities"
                    defaultMessage="Amenities"
                  />
                </Text>
              </Box>
              <Text variant="bodyM" dir="auto">
                {amenities}
              </Text>
            </Box>
          )}
          {business_amenities && (
            <div>
              <Box marginBottom="s300">
                <Text variant="labelM">
                  <FormattedMessageWrapper
                    id="businessAmenities"
                    defaultMessage="Business amenities"
                  />
                </Text>
              </Box>
              <Text variant="bodyM" dir="auto">
                {business_amenities}
              </Text>
            </div>
          )}
          {(amenities || business_amenities) && (
            <Box paddingBottom="s700" paddingTop="s700">
              <Divider />
            </Box>
          )}
          {dining && (
            <>
              <div>
                <Box display="flex" alignItems="center" marginBottom="s400">
                  <Text variant="labelM">
                    <FormattedMessageWrapper
                      id="dining"
                      defaultMessage="Dining"
                    />
                  </Text>
                </Box>
                <Text variant="bodyM" dir="auto">
                  {dining}
                </Text>
              </div>
              {/* Divider between dining and rooms */}
              <Box paddingBottom="s700" paddingTop="s700">
                <Divider />
              </Box>
            </>
          )}
          {rooms && (
            <>
              <div>
                <Box display="flex" alignItems="center" marginBottom="s400">
                  <Text variant="labelM">
                    <FormattedMessageWrapper
                      id="rooms"
                      defaultMessage="Rooms"
                    />
                  </Text>
                </Box>
                <Text variant="bodyM" dir="auto">
                  {rooms}
                </Text>
              </div>
              {/* Divider between dining and rooms */}
              <Box paddingBottom="s700" paddingTop="s700">
                <Divider />
              </Box>
            </>
          )}
          <Box paddingBottom="s700">
            <HotelLocationContent
              descriptions={descriptions}
              attractions={attractions}
              variant="detailsTab"
            />
          </Box>
        </div>
      )
    }
  }
}

export default HotelPropertyInfoContent
